import App from './App.svelte';



let elmx = JSON.parse(document.querySelector('#calcapp').dataset.packs);
let elperpack = document.querySelector('#calcapp').dataset.currentcount;
let mximg = document.querySelector('#calcapp').dataset.image;
let mxtitle = document.querySelector('#calcapp').dataset.title;
let counttext = document.querySelector('#calcapp').dataset.counttext;
let unit = document.querySelector('#calcapp').dataset.unit;
let good_id = document.querySelector('#calcapp').dataset.goodid;
let total_price = document.querySelector('#calcapp').dataset.totalprice;



const app = new App({
	target: document.getElementById('calcapp'),
	props: {
		currentCount: 1,
		image: mximg,
		perpack: elperpack,
		title: mxtitle,
		unit: unit,
		counttext: counttext,
		item: {
			packs: elmx
        },
        goodId: good_id,
        totalPrice: total_price
	}
});

export default app;